'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function LoginController($filter, $scope, Auth, Toast) {
	'ngInject';

	var vm = this;
	vm.login = login;

	function login(params) {
		var hasErrors = false;

		angular.forEach($scope.login.$error.required, function () {
			hasErrors = true;

			return false;
		});

		if (hasErrors || $scope.login.email.$error.email) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		Auth.login(params).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			}
		});
	}
}

exports['default'] = LoginController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/login_screen/login.controller.js
 **/